export const fieldDataTypes = Object.freeze({
  text: 0,
  integer: 1,
  float: 2,
  date: 3,
});

export default {};
